export default {
  getListCatalog: state => state.listCatalog,
  getListCatalogFilter: state => state.listCatalogFilter,
  getLoadingFilterCategories: state => state.loadingCategories
}
